// extracted by mini-css-extract-plugin
export default {"LegendItem":"zFvyF","LegendHeader":"G4NSQ","LegendItemMuted":"CwZ3W","Legend":"sQuRG","none":"Or6mk","vertical":"oMCKr","horizontal":"k8R4C","DashCard":"JdSfp"};